<template>
  <!-- カードクリックでダイアログ表示 -->
  <div
    @click="showDialog(true)"
    @contextmenu.prevent="openContextMenu()"
    class="chatbot-card"
    :class="{
      // テンプレートリスト画面での表示
      'template-list': parent === DISP_MODE.TEMPLATE_LIST,
      // ロボリスト画面での表示
      'robo-list': parent === DISP_MODE.ROBO_LIST && !isMenuMiniSize,
      'robo-list-thin-menu': parent === DISP_MODE.ROBO_LIST && isMenuMiniSize,
      // シナリオ編集画面での表示
      'scenario-list': parent === DISP_MODE.SCENARIO_LIST,
  }">
    <!-- ロボ詳細ダイアログ -->
    <portal to="modal-robo-list" v-if="isShowRoboDetail">
      <RoboDetail
        :isShowModal="isShowRoboDetail"
        :chatbot="robo"
        :mediaCooperationItemMasterNameList="mediaCooperationItemMasterNameList"
        :userChatBotBookMark="userChatBotBookMark"
        :users="users"
        :user="user"
        :sitemapRootList="sitemapRootList"
        :sitemapEmploymentList="sitemapEmploymentList"
        :usersStatusAPI="usersStatusAPI"
        @cancel="showDialog"
        @setIcon="setIcon"
        @changeBookMark="changeBookMark"
        @movePartsEdit="movePartsEdit"
        @updateChatBot="updateRobo"
        @deleteChatBot="deleteRobo"
        @clickRoboLock="clickRoboLock"
        :PCTRLLOG="CTRLLOG"
      />
    </portal>
    <!-- メール送付・定期ダイアログ -->
    <portal to="modal-robo-list" v-if="isShowModalReqularMail">
      <ModalRegularSending
        :isShowModal="isShowModalReqularMail"
        :users="users"
        :chatbot="robo.bot_id"
        :media_type="RegularSendingModalType"
        :usersStatusAPI="usersStatusAPI"
        @cancel="showRegMail"
        :PCTRLLOG="CTRLLOG"
      />
    </portal>
    <portal to="modal-robo-list" v-if="isDetailURLSetting">
      <DetailURLSetting
        :isShowModal="isDetailURLSetting"
        :chatbot="robo"
        @cancel="changeURLSetting"/>
    </portal>
    <!-- ロボ削除確認ダイアログ -->
    <portal to="modal-robo-list" v-if="isRoboDelete">
      <ModalDeleteChatBot
        :isShowModal="isRoboDelete"
        :deleteIndex="deleteIndex"
        @deleteComplete="deleteChatbotComplete"
        @cancel="showDeleteChatbot"
        :PCTRLLOG="CTRLLOG"
      />
    </portal>
    <!-- ロボ雇用ダイアログ -->
    <portal to="modal-robo-employment" v-if="isShowTemplateRoboDetail">
      <TemplateRoboDetail
        :isShowModal="isShowTemplateRoboDetail"
        :templateRobo="robo"
        :user="user"
        @cancel="showDialog"
        :PCTRLLOG="CTRLLOG"
      />
    </portal>

    <!-- ロボ雇用画面(テンプレート一覧)表示用 -->
    <template v-if="parent === DISP_MODE.TEMPLATE_LIST">
      <div class="template-frame">
        <div class="card-upper">
          <!-- ロボアイコンとサンプルパーツ画像(動画のサムネイル) -->
          <div class="image-box">
            <div class="icon-box">
              <img class="robo-icon" :src="getIconURL()">
            </div>
          </div>
          <!-- サンプルデモ -->
          <div class="scenario-demo">
            <TemplateRoboScenarioDemo
              :templateRobo="robo"
            />
          </div>
        </div>
        <div class="card-bottom">
          <!-- タグ -->
          <div>
            <ChatBotTags
              :chatbot="robo"
              :isEdit="false"
              :isNew="false"
              :isTemplate="true"
            />
          </div>
          <!-- ツールチップにてロボ名のフルネームを表示 -->
          <b-tooltip type="is-dark" multilined :label="robo.name" position="is-bottom">
            <!-- ロボ名 -->
            <div class="template-robo-name">
              {{robo.name}}
            </div>
          </b-tooltip>
        </div>
      </div>
    </template>
    <!-- ロボ一覧画面表示用 -->
    <template v-else-if="parent === DISP_MODE.ROBO_LIST">
      <div class="robo-list-frame">
        <div class="robo-icon-box">
          <div class="status-mark-box">
            <!-- 編集権限 -->
            <span class="mdi mdi-account-edit status-mark" v-if="getEditPermission">
              <p class="status-message">
                編集可
              </p>
            </span>
            <span class="mdi mdi-account-key status-mark" v-else>
              <p class="status-message">
                閲覧のみ
              </p>
            </span>
            <!-- 親ロボ -->
            <span class="mdi mdi-account-multiple status-mark" v-if="getMiniRobo">
              <p class="status-message">
                ミニロボあり
              </p>
            </span>
            <span class="mdi mdi-account status-mark" v-else>
              <p class="status-message">
                ミニロボなし
              </p>
            </span>
            <!-- 出勤中 -->
            <span class="mdi mdi-seat-recline-normal status-mark" v-if="getWork">
              <p class="status-message">
                出勤中
              </p>
            </span>
            <span class="mdi mdi-bell-sleep status-mark" v-else>
              <p class="status-message">
                待機中
              </p>
            </span>
          </div>
          <!-- ロボアイコン -->
          <div class="icon-box">
            <img class="robo-icon" :src="getIconURL()">
          </div>
        </div>
        <div class="robo-name-box">
          <!-- ロボ名、作成日、タグ -->
          <div>
            <!-- ツールチップにてロボ名のフルネームを表示 -->
            <b-tooltip type="is-dark" class="robo-name-tooltip" multilined :label="robo.name" position="is-bottom">
              <!-- テンプレートマーク -->
              <span class="mdi mdi-shopping" v-if="robo.is_template">テンプレートロボ</span>
              <!-- ロボ名 -->
              <p class="employment-robo-name">
                {{robo.name}}
              </p>
            </b-tooltip>
            <!-- 作成日 -->
            <p class="robo-created-date">
              作成日：{{dateFormat(robo.created_at)}}
            </p>
            <!-- タグ -->
            <ChatBotTags
              :chatbot="robo"
              :isEdit="false"
              :isNew="false"
            />
          </div>
        </div>
        <div class="robo-contact-box">
          <!-- コンタクトボタンとシングルページURL -->
          <div class="contact-button-box">
            <!-- メールボタン -->
            <button
              class="button is-primary is-small contact-button"
              @click.stop="showRegMail(true, 'Email')"
              :disabled="!robo.is_confirm"
            >
              メール
            </button>
            <!-- SMSボタン -->
            <button
              class="button is-primary is-small contact-button"
              @click.stop="showRegMail(true, 'SMS')"
              :disabled="!robo.is_confirm"
            >
              SMS
            </button>
            <!-- 出勤ボタン -->
            <button
              class="button is-primary is-small contact-button"
              @click.stop="changeURLSetting(true)"
            >
              出勤
            </button>
            <!-- ToDo -->
            <!-- 「メール送信・定期」と同じ感じの機能 -->
            <!-- 現状ユーザーには携帯電話番号を登録していないので、そのあたりも含めて実装が必要 -->
            <!-- SMSボタン -->
            <!-- <button class="button is-primary is-small contact-button">SMS</button> -->

            <!-- ToDo -->
            <!-- LINEのブロードキャスト(マルチキャスト？)メッセージでロボリンクを送る -->
            <!-- LINEボタン -->
            <!-- <button class="button is-primary is-small contact-button">LINE</button> -->
          </div>
          <div class="robo-link-box">
            <input type="url" id="copy_code_detail_setting" class="robo-link" disabled="true" v-model="robolink" />
            <button class="button is-primary is-small" @click.stop="copySinglePageURL()">コピー</button>
          </div>
        </div>
        <div class="robo-qrcode-box">
          <!-- QRコード -->
          <vue-qrcode v-if="robolink" :value="robolink" :options="qrCodeOptions" tag="img" :id="'roboQrCode_' + robo.bot_id"></vue-qrcode>
          <a class="button qrcode-download" @click.stop="qrCodeDownload()">
            QRコード保存
          </a>
        </div>
      </div>

    </template>
    <!-- シナリオ編集画面表示用 -->
    <template v-else-if="parent === DISP_MODE.SCENARIO_LIST">
      <div class="scenario-list-frame">
        <!-- テンプレートマークとロボ名 -->
        <!-- テンプレートロボではない場合は、ロボ名のみ表示 -->
        <div class="edit-robo-header">
          <!-- テンプレートマーク -->
          <div class="edit-robo-header-left-box" v-if="robo.is_template">
            <span class="mdi mdi-shopping"/>
          </div>
          <!-- テンプレートロボ名 -->
          <div class="edit-robo-header-right-box" v-if="robo.is_template">
            <!-- ツールチップにてロボ名のフルネームを表示 -->
            <b-tooltip type="is-dark" multilined :label="robo.name" position="is-bottom">
              <p class="edit-template-robo-name" v-show="robo.is_template">
                {{robo.name}}
              </p>
            </b-tooltip>
          </div>
          <!-- ロボ名 -->
          <div class="edit-robo-header-center-box" v-else>
            <!-- ツールチップにてロボ名のフルネームを表示 -->
            <b-tooltip type="is-dark" multilined :label="robo.name" position="is-bottom">
              <p class="edit-robo-name">
                {{robo.name}}
              </p>
            </b-tooltip>
          </div>
        </div>
        <!-- タグとアイコン -->
        <div class="edit-robo-body">
          <!-- タグ -->
          <div class="edit-robo-body-left-box">
            <ChatBotTags
              :chatbot="robo"
              :isEdit="false"
              :isNew="false"
            />
          </div>
          <!-- ロボアイコン -->
          <div class="edit-robo-body-right-box">
            <div class="icon-box">
              <img class="robo-icon" :src="getIconURL()">
            </div>
          </div>
        </div>
      </div>

    </template>
  </div>
</template>

<script>
import { mapState }             from 'vuex'
import RoboDetail               from '@/components2/Robo/modal/organisms/ModalChatBotDetails'
import DetailURLSetting         from '@/components2/Robo/modal/DetailURLSetting'
import ModalDeleteChatBot       from '@/components2/Robo/modal/ModalDeleteChatBot'
import TemplateRoboDetail       from '@/components2/Robo/modal/TemplateRoboDetail'
import ModalRegularSending         from '@/components2/Robo/modal/ModalRegularSending'
import TemplateRoboScenarioDemo from '@/components2/Robo/modal/organisms/TemplateRoboScenarioDemo'
import ChatBotTags              from '@/components2/Common/Screen/organisms/ChatBotTags'
import Tooltip                  from '@/components/atoms/tooltips/Tooltip'
import VueQrcode                from "@chenfengyuan/vue-qrcode"
import controlLogMixin          from '@/mixins/controlLogMixin'
import {
  isRoboEditPermission
} from '@/functions/checkPermission'
import moment from 'moment'

export default {
  name: 'RoboCard',
  componentName: 'RoboCard',
  components: {
    RoboDetail,
    DetailURLSetting,
    ModalDeleteChatBot,
    TemplateRoboDetail,
    ModalRegularSending,
    TemplateRoboScenarioDemo,
    ChatBotTags,
    Tooltip,
    VueQrcode,
    isRoboEditPermission,
  },
  mixins: [
    controlLogMixin,
  ],
  props: {
    /**
     * カード表示形式
     * @type {String}
     */
    parent: {
      type: String,
      require: true
    },
    /**
     * ロボデータ
     * @type {Object}
     */
    robo: {
      type: Object,
      require: true
    },
    /**
     * 媒体連携項目マスター一覧
     * @type {Array}
     */
    mediaCooperationItemMasterNameList: {
      type: Array,
      require: false
    }
  },
  computed: {
    ...mapState('chatbot', ['chatbots']),
    ...mapState('auth', ['user', 'users', 'userChatBotBookMark', 'usersStatusAPI']),
    ...mapState('mediapool', ['images']),
    ...mapState('sitemap', ['sitemapRootList', 'sitemapRecruitList', 'sitemapCustomList', 'sitemapEmploymentList']),
    ...mapState("setting",["isMenuMiniSize"]),
    getEditPermission () {
      return this.isEditPermission
    },
    getMiniRobo () {
      return this.isMini
    },
    getWork () {
      return this.isWork
    },
  },
  data () {
    return {
      /**
       * カード表示形式
       * @type {String}
       */
      DISP_MODE: {
        TEMPLATE_LIST: 'template-list',
        ROBO_LIST: 'robo-list',
        SCENARIO_LIST: 'scenario-list'
      },
      /**
       * ロボ詳細ダイアログ開閉フラグ
       * @type {Boolean}
       */
      isShowRoboDetail: false,
      /**
       * テンプレートロボ詳細ダイアログ開閉フラグ
       * @type {Boolean}
       */
      isShowTemplateRoboDetail: false,
      /**
       * メール送付・定期ダイアログ開閉フラグ
       * @type {Boolean}
       */
      isShowModalReqularMail: false,
      /**
       * 送付・定期ダイアログタイプ(Email/SMS)
       * @type {String}
       */
      RegularSendingModalType: "",
      /**
       * 出勤ダイアログ開閉フラグ
       * @type {Boolean}
       */
      isDetailURLSetting: false,
      /**
       * ロボ削除確認ダイアログ開閉フラグ
       * @type {Boolean}
       */
      isRoboDelete: false,
      /**
       * 削除ロボID
       * @type {String}
       */
      deleteIndex: 0,
      /**
       * ロボリンクURL
       * @type {String}
       */
      robolink: '',
      /**
       * QRコード用オプション
       * @type {Object}
       */
      qrCodeOptions: {
        margin: 2,
        errorCorrectionLevel: "M",
        maskPattern: 0,
        scale: 1,
        width: 100,
        color: {
          dark: "#000000FF",
          light: "#FFFFFFFF"
        }
      },
      iconUrl: '',
      /**
       * 編集権限
       * @type {Boolean}
       */
      isEditPermission: false,
      /**
       * ミニロボあり/なし
       * @type {Boolean}
       */
      isMini: false,
      /**
       * 勤務中
       * @type {Boolean}
       */
      isWork: false,
    }
  },
  watch: {
    chatbots () {
      // ロボリストを初期化
      this.getIconURL()
      this.isRoboEditPermission()
      this.isMiniBot()
      this.isOnBot()
    },
    sitemapRootList () {
      // ロボリストを初期化
      this.isOnBot()
    },
    sitemapRecruitList () {
      // ロボリストを初期化
      this.isOnBot()
    },
    sitemapCustomList () {
      // ロボリストを初期化
      this.isOnBot()
    }
  },
  mounted () {
    if (this.parent === this.DISP_MODE.ROBO_LIST) {
      this.$nextTick(() => {
        // ロボリンクを作成する
        this.robolink = process.env.OWN_ENDPOINT + '/single/' + this.robo.group + '/' + this.robo.bot_id
        // デフォルトアイコンを取得しておく
        this.iconUrl = require('@/assets/template/robot.png')
        // ロボアイコン取得
        this.getIconURL()
        // 編集権限取得
        this.isRoboEditPermission()
        // ミニロボ検索
        this.isMiniBot()
        // 勤務中検索
        this.isOnBot()
      })
    }
    this.iconUrl = require('@/assets/template/robot.png')
  },
  methods: {
    /**
     * ロボ詳細ダイアログの開閉
     * @param {Boolean} flag ダイアログ開閉フラグ
     */
    showDialog (flag) {
      if (this.parent === this.DISP_MODE.TEMPLATE_LIST) {
        // ロボ雇用ダイアログを開く
        this.isShowTemplateRoboDetail = flag
      } else if (this.parent === this.DISP_MODE.ROBO_LIST) {
        // ロボを選択状態にする
        this.$store.dispatch('chatbot/selectChatbot', this.robo)
        // ロボ詳細ダイアログを開く
        this.isShowRoboDetail = flag
      }
    },
    /**
     * 右クリックのダミーメソッド
     * ※コンテキストメニューを表示する時に使う
     * 2ndでコンテキストメニュー実装の予定があったが未実装
     * 3rdで不要になるようであれば削除予定
     */
    openContextMenu () {
      return
    },
    /**
     * メール送付・定期ダイアログの開閉
     * @param {Boolean} flag ダイアログ開閉フラグ
     */
    showRegMail (flag, media_type) {
      this.isShowModalReqularMail = flag
      if (flag) this.RegularSendingModalType = media_type
    },
    /**
     * 起動設定ダイアログの開閉
     */
    changeURLSetting (flag) {
      this.isDetailURLSetting = flag
    },
    /**
     * ロボ削除確認ダイアログの開閉
     */
    showDeleteChatbot (flag) {
      this.isRoboDelete = flag
    },
    /**
     * 日付フォーマット
     * @param {Date} targetDate 日付
     */
    dateFormat (targetDate) {
      return moment(targetDate).format('YYYY/MM/DD')
    },
    /**
     * サンプル動画の再生
     */
    moviePlay () {
      // マウスホバーで再生する
      this.$refs.sampleMovie.play()
    },
    /**
     * サンプル動画の停止
     */
    movieStop () {
      // マウスホバーが外れたら停止する
      this.$refs.sampleMovie.pause()
      // 再生位置を最初に戻す
      this.$refs.sampleMovie.currentTime = 0
    },
    /**
     * ロボ編集権限確認
     */
    isRoboEditPermission () {
      this.isEditPermission = isRoboEditPermission(this.robo, this.user)
      return this.isEditPermission
    },
    /**
     * ミニロボ確認
     */
    isMiniBot () {
      let isMini = false
      if (this.robo.chatbot_mini && this.robo.chatbot_mini.length > 0) {
        isMini = true
      }
      this.isMini = isMini
      return this.isMini
    },
    /**
     * アイコン画像取得
     */
    getIconURL () {
      if (this.robo.icon_data) {
        this.iconUrl = this.robo.icon_data
      }
      return this.iconUrl
    },
    /**
     * ロボ起動確認
     */
    isOnBot () {
      // 1つでも検索出来たら設置中
      this.isWork = Boolean(this.isOnBotSitemap() | this.isOnBotRecruit() | this.isOnBotCustom())
      return this.isWork
    },
    /**
     * ホームページ設置中確認
     */
    isOnBotSitemap () {
      let root_apply_list = false
      // ロボの起動設定チェック
      if (this.robo.chatbot_mini && this.robo.chatbot_mini.length > 0) {
        // ミニロボを持っている場合、サイトマップに登録されているミニロボを探す
        root_apply_list = this.sitemapRootList.some(
          root => root.node_list.some(
            // 当該ロボが設置中か探す
            node => node.apply_robo_list.some(
              applyRobo => applyRobo.data.bot_id === this.robo.bot_id
            ) ||
            // 持っているミニロボ全てを設置中から探す
            node.apply_minirobo_list.some(
              applyMinirobo => this.robo.chatbot_mini.some(
                // 当該ミニロボが設置中か探す
                childe => applyMinirobo.data.bot_id === childe.bot_id
              )
            )
          )
        )
      } else {
        // ミニロボを持っていない場合、サイトマップに登録されているロボを探す
        root_apply_list = this.sitemapRootList.some(
          root => root.node_list.some(
            // 当該ロボが設置中か探す
            node => node.apply_robo_list.some(
              applyRobo => applyRobo.data.bot_id === this.robo.bot_id
            )
          )
        )
      }
      return root_apply_list
    },
    /**
     * 求人ページ設置中確認
     */
    isOnBotRecruit () {
      let recruit_apply_list = false
      // ロボの起動設定チェック
      if (this.robo.chatbot_mini && this.robo.chatbot_mini.length > 0) {
        // ミニロボを持っている場合、カスタムページに登録されているミニロボを探す
        recruit_apply_list = this.sitemapRecruitList.some(
          recruit => recruit.apply_robo_list.some(
            // 当該ロボが設置中か探す
            applyRobo => applyRobo.data.bot_id === this.robo.bot_id
          ) ||
          recruit.apply_minirobo_list.some(
            // 持っているミニロボ全てを設置中から探す
            applyMinirobo => this.robo.chatbot_mini.some(
              // 当該ミニロボが設置中か探す
              childe => applyMinirobo.data.bot_id === childe.bot_id
            )
          )
        )
        // 1つでも検索出来たら設置中
      } else {
        // ミニロボを持っていない場合、カスタムページに登録されているロボを探す
        recruit_apply_list = this.sitemapRecruitList.some(
          recruit => recruit.apply_robo_list.some(
            // 当該ロボが設置中か探す
            applyRobo => applyRobo.data.bot_id === this.robo.bot_id
          )
        )
      }

      // 1つでも検索出来たら設置中
      return recruit_apply_list
    },
    /**
     * カスタムページ設置中確認
     */
    isOnBotCustom () {
      let custom_apply_list = false
      // ロボの起動設定チェック
      if (this.robo.chatbot_mini && this.robo.chatbot_mini.length > 0) {
        // ミニロボを持っている場合、カスタムページに登録されているミニロボを探す
        custom_apply_list = this.sitemapCustomList.some(
          custom => custom.apply_robo_list.some(
            // 当該ロボが設置中か探す
            applyRobo => applyRobo.data.bot_id === this.robo.bot_id
          ) ||
          custom.apply_minirobo_list.some(
            // 持っているミニロボ全てを設置中から探す
            applyMinirobo => this.robo.chatbot_mini.some(
              // 当該ミニロボが設置中か探す
              childe => applyMinirobo.data.bot_id === childe.bot_id
            )
          )
        )
        // 1つでも検索出来たら設置中
      } else {
        // ミニロボを持っていない場合、カスタムページに登録されているロボを探す
        custom_apply_list = this.sitemapCustomList.some(
          custom => custom.apply_robo_list.some(
            // 当該ロボが設置中か探す
            applyRobo => applyRobo.data.bot_id === this.robo.bot_id
          )
        )
      }

      // 1つでも検索出来たら設置中
      return custom_apply_list
    },
    /**
     * ロボリンクコピー
     */
    copySinglePageURL () {
      navigator.clipboard.writeText(this.robolink)
        .then(() => {
          this.$buefy.snackbar.open({
            message: 'ロボ表示URLをコピーしました！',
            type: 'is-success',
            position: 'is-top',
            actionText: 'OK',
            indefinite: true
          })
        })
        .catch(e => {
          console.error(e)
        })
    },
    /**
     * ロボリンクQRコードダウンロード
     */
    qrCodeDownload () {
      // QRコードのimg要素取得
      let roboQrCodeImage = document.getElementById("roboQrCode_" + this.robo.bot_id)

      // aタグ要素を作成してQRコードの画像を割り当てる
      const aTag = document.createElement("a")
      document.body.appendChild(aTag)
      aTag.download = this.robo.name + 'QRコード.png'
      aTag.href = roboQrCodeImage.src
      // 画像をダウンロードする
      aTag.click()
      aTag.remove()
      URL.revokeObjectURL(roboQrCodeImage.src)
    },
    /**
     * お気に入り更新
     * @param {Object} robo ロボデータ
     */
    changeBookMark (robo) {
      const target = this.userChatBotBookMark.filter(bookmarkRobo => bookmarkRobo.chatbot === robo.bot_id)
      if (target.length > 0) {
        this.$store.dispatch('auth/deleteUserChatBotBookMark', target[0].pk)
      } else {
        let cbTemp = {
          chatbot: robo.bot_id,
          user: this.user.userHash
        }
        this.$store.dispatch('auth/createUserChatBotBookMark', cbTemp)
      }
      this.sendControlLogRelatedChatBot('ロボお気に入り', 'ロボのお気に入りを更新。', robo)
    },
    /**
     * ロボアイコン更新
     * @param {Object} robo ロボデータ
     */
    setIcon (data) {
      // ミニロボの画像変更とそれ以外
      if (data.miniIdx >= 0) {
        let updateMiniRoboTemp = data.chatbot.chatbot_mini[data.miniIdx]
        if (data.id) {
          for (const i of this.images) {
            if (i.image_id == data.id) {
              updateMiniRoboTemp["icon_ref"] = i.pk
              updateMiniRoboTemp["icon_data"] = i.image_data
              this.$store.dispatch('chatbot/updateChatBotMini', updateMiniRoboTemp)
              this.sendControlLogRelatedChatBot('アイコン変更', 'ミニロボのアイコンを変更。', updateMiniRoboTemp)
              break
            }
          }
        } else {
          updateMiniRoboTemp["icon_ref"] = null
          updateMiniRoboTemp["icon_data"] = null
          this.$store.dispatch('chatbot/updateChatBotMini', updateMiniRoboTemp)
          this.sendControlLogRelatedChatBot('アイコン変更', 'ミニロボのアイコンを削除。', updateMiniRoboTemp)
        }
      } else {
        if (data.id) {
          this.$store.dispatch('chatbot/setChatBotIcon', {
            name: data.chatbot.name,
            id: data.chatbot.bot_id,
            image_id: data.id
          })
          this.sendControlLogRelatedChatBot('アイコン変更', 'ロボのアイコンを変更。', data.chatbot)
        } else {
          this.$store.dispatch('chatbot/setChatBotIcon', {
            name: data.chatbot.name,
            id: data.chatbot.bot_id,
            image_id: null
          })
          this.sendControlLogRelatedChatBot('アイコン変更', 'ロボのアイコンを削除。', data.chatbot)
        }
      }
    },
    /**
     * シナリオ編集画面に遷移
     * @param {Object} robo ロボデータ
     */
    movePartsEdit (robo) {
      this.$store.dispatch('chatbot/setScenarioTitleBeforeChange', '')
      this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: robo.scenario_name })
      this.$store.dispatch('chatbot/selectChatbot', robo)
      this.$router.push('/dashboard/chatbot?view=scenario&scenario=' + robo.scenario_name)
    },
    /**
     * ロボ更新
     * @param {Object} robo ロボデータ
     */
    updateRobo (robo) {
      this.$store.dispatch('chatbot/setChatBot', robo)
    },
    /**
     * ロボ削除
     * @param {Object} robo ロボデータ
     */
    deleteRobo (robo) {
      this.isRoboDelete = true
      this.deleteIndex = robo.bot_id
      this.sendControlLogRelatedChatBot('ロボ削除', 'ロボを削除。', robo)
    },
    deleteChatbotComplete () {
      alert('ロボの削除を行いました。')
      this.isRoboDelete = false
      this.isShowRoboDetail = false
    },
    /**
     * ロボロック
     * @param {Object} robo ロボデータ
     */
    clickRoboLock (robo) {
      this.$store.dispatch('chatbot/setChatBot', robo)
      this.sendControlLogRelatedChatBot('ロボロック', 'ロボのロック状態を変更。', robo)
    }
  },
}
</script>

<style lang="scss" scoped>
// テンプレートロボ一覧
.template-list {
  transition: 0.2s;
}
.template-list:hover {
  transform: scale(1.02);
}
// 雇用ロボ一覧
.robo-list {
  width: calc(100vw - 290px);
  transition: 0.2s;
}
.robo-list-thin-menu {
  width: calc(100vw - 145px);
  transition: 0.2s;
}
.robo-list:hover {
  transform: scale(1.02);
}
// シナリオ編集画面ロボ一覧
.scenario-list {
  transition: 0.2s;
}
.scenario-list:hover {
  transform: scale(1.05);
}
// ロボアイコン共通CSS
@mixin icon-box($img-width: 100%, $img-height: 100%) {
  text-align: center;
  .robo-icon {
    width: $img-width;
    height: $img-height;
    object-fit: cover;
    border-radius: 50%;
    border: solid thin #ccc;
    background-color: white;
  }
}
// ロボカード表示
.chatbot-card {
  cursor: pointer;
  padding: 8px;
  margin: 8px;
  border: solid thin #ccc;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  // テンプレートロボ
  .template-frame {
    width: 300px;
    height: 318px;
    border: 2px solid gray;
    border-radius: 10px;
  }
  .card-upper {
    padding: 4px;
    background: rgba(255,200,200,0.4);
    height: 240px;
    display: flex;
    justify-content: left;
    position: relative;
    .image-box {
      position: absolute;
      z-index: 100;
      @include icon-box(50px, 50px);
    }
    .scenario-demo {
      margin-top: 32px;
      width:100%;
      height: 75%;
    }
  }
  .card-bottom {
    padding: 8px;
    .template-robo-name {
      font-size: 14px;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      -webkit-text-overflow: ellipsis;
    }
  }
  // 雇用ロボ
  .robo-list-frame {
    min-width: 100%;
    max-width: 100%;
    padding: 8px;
    display: flex;
    justify-content: left;
    align-items: center;
    position: relative;
    .robo-icon-box {
      align-items: center;
      min-width: 250px;
      display: flex;
      position: relative;
      .status-mark-box {
        width: 100px;
        .status-mark {
          margin-right: 10px;
          display: flex;
          align-items: center;
          .status-message {
            padding: 4px;
            font-size: 10px;
          }
        }
      }
      @include icon-box(120px, 120px);
    }
    .robo-name-box {
      width: 25%;
      padding-right: 4px;
      text-align: left;
      .robo-name-tooltip {
        width: 100%;
      }
      .employment-robo-name {
        width: auto;
        padding: 6px;
        font-size: 18px;
        font-weight: 600;
        text-align: left;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-text-overflow: ellipsis;
      }
      .robo-created-date {
        padding: 6px;
        font-size: 14px;
      }
    }
    .robo-contact-box {
      width: 40%;
      padding-right: 4px;
      text-align: left;
      .contact-button-box {
        padding: 8px;
        .contact-button {
          width: 80px;
        }
      }
      .robo-link-box {
        padding: 8px;
        display: flex;
        align-items: center;
        position: relative;
        .robo-link {
          border-radius:5px;
          width: 100%;
          height: 30px;
        }
      }
    }
    .robo-qrcode-box {
      width: 20%;
      display: grid;
      align-items: center;
      justify-content: center;
      position: relative;
      .qrcode-download {
        width: 100px;
        align-items: center;
        text-align: center;
        font-size: 11px;
        font-weight: 600;
      }
    }
  }
  // シナリオ編集ロボ
  .scenario-list-frame {
    width: 170px;
    height: 150px;
    // テンプレートマークとロボ名
    .edit-robo-header {
      width: 100%;
      padding: 4px;
      display: flex;
      justify-content: left;
      position: relative;
      // テンプレートマーク
      // (親クラスの左padding分マイナス)
      .edit-robo-header-left-box {
        width: calc(20px - 4px);
        padding-right: 4px;
      }
      // ロボ名(テンプレートマークなし)
      .edit-robo-header-center-box {
        width: 100%;
      }
      // ロボ名(テンプレートマークあり)
      // (親クラスの右padding分マイナス)
      .edit-robo-header-right-box {
        width: calc(150px - 4px);
        padding-left: 4px;
      }
      .b-tooltips {
        width: 100%;
      }
      // ロボ名
      .edit-robo-name {
        width: 170px;
        padding: 4px;
        text-align: left;
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-text-overflow: ellipsis;
      }
      // テンプレートロボ名
      .edit-template-robo-name {
        width: 150px;
        padding: 4px;
        text-align: left;
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-text-overflow: ellipsis;
      }
    }
    .edit-robo-body {
      width: 100%;
      padding: 4px;
      display: flex;
      justify-content: center;
      position: relative;
      // 要素左寄せ(親クラスの左padding分マイナス)
      $left-box-width: calc(80px - 4px);
      .edit-robo-body-left-box {
        width: $left-box-width;
        margin-right: auto;
        padding-right: 4px;
      }
      // 要素右寄せ(親クラスの右padding分マイナス)
      $right-box-width: calc(90px - 4px);
      .edit-robo-body-right-box {
        width: $right-box-width;
        margin-left: auto;
        padding-top: 12px;
        padding-left: 4px;
        @include icon-box($right-box-width, $right-box-width);
      }
    }
  }
  .main-box {
    margin-top: 8px;
    display: flex;
    width: 100%;
    .icon-area {
      margin: auto;
      width:  60px;
      height: 60px;
      .icon-wrapper {
        position: relative;
        width: 100%;
        height: 100%;
        .robo-icon {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 50%;
          background: white;
          border: solid thin #ccc;
        }
        .minirobo-icon-base {
          position: absolute;
          width: 50%;
          height: 50%;
          right: -12.5%;
          bottom: -12.5%;
          border-radius: 50%;
          background: white;
          border: solid thin #ccc;
          .minirobo-icon {
            object-fit: cover;
            border-radius: 50%;
            width: 100%;
            height: 100%;
            opacity: 0.5;
          }
        }
        .minirobo-num {
          position: absolute;
          font-size: 16px;
          font-weight: bold;
          bottom: 5%;
          right: -20%;
        }
      }
    }
    .desc {
      padding-left: 24px;
      width: calc(100% - 60px);
      margin: auto;
      p {
        width: 100%;
        font-size: 13px;
        text-align: left;
      }
    }
  }
}
/deep/ .tooltip {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>


// WEBPACK FOOTER //
// src/components2/Robo/modal/RoboCard.vue